import { render, staticRenderFns } from "./ViewportDebugPanel.vue?vue&type=template&id=4ff286d4&scoped=true&"
import script from "./ViewportDebugPanel.vue?vue&type=script&lang=js&"
export * from "./ViewportDebugPanel.vue?vue&type=script&lang=js&"
import style0 from "./ViewportDebugPanel.vue?vue&type=style&index=0&id=4ff286d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/cartaz-pratico/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff286d4",
  null
  
)

export default component.exports